{
  "modules": [
    {
      "number": "01",
      "title": "",
      "lessons": [
        {
          "number": "1",
          "title": "Lesson 1",
          "description": "Placeholder — replace with the real lesson description.",
          "duration": "0:00",
          "preview": true
        },
        {
          "number": "2",
          "title": "Lesson 2",
          "description": "Placeholder — replace with the real lesson description.",
          "duration": "0:00"
        },
        {
          "number": "3",
          "title": "Lesson 3",
          "description": "Placeholder — replace with the real lesson description.",
          "duration": "0:00"
        },
        {
          "number": "4",
          "title": "Lesson 4",
          "description": "Placeholder — replace with the real lesson description.",
          "duration": "0:00"
        },
        {
          "number": "5",
          "title": "Lesson 5",
          "description": "Placeholder — replace with the real lesson description.",
          "duration": "0:00"
        }
      ]
    }
  ]
}
